export const getMfRedirect = (currentPath: string): string | null => {
  const match = currentPath.match(
    /^\/personal-investing\/tools\/nasu\/mutual-fund\/general-investing\/(individual|joint|ugma-utma)\/?$/
  );
  if (!match) {
    return null;
  }
  const flow = match[1];
  return `/personal-investing/new-account/setup/mutual-fund/general-investing/${flow}/checklist`;
};
